module.exports = __webpack_public_path__ + "img/ft3.6ace0806.png";